<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.active" persistent width="600">
      <v-card>
        <v-card-title class="headline">{{
          $t("components.dialogs.resetBoatDialog.areYouSure")
        }}</v-card-title>
        <v-card-text>
          {{
            $t(
              "components.dialogs.resetBoatDialog.doYouReallyWantToResetThisDeviceIncludingAllDataHistoryLogAndPlatformBoatThisActionCannotBeUndone"
            )
          }}
        </v-card-text>

        <v-card-text
          >{{
            $t(
              "components.dialogs.resetBoatDialog.enterSentinelSNToConfirmDeviceReset"
            )
          }}
        </v-card-text>

        <v-card-text>
          <v-text-field
            v-model="sentinelSn"
            :label="$t('components.dialogs.resetBoatDialog.sentinelSN')"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onDisagree()">{{
            $t("components.dialogs.resetBoatDialog.cancel")
          }}</v-btn>
          <v-btn
            color="primary"
            :disabled="sentinelSn !== dialog.sentinelSn"
            text
            @click="onAgree()"
            >{{ $t("components.dialogs.resetBoatDialog.yesReset") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      sentinelSn: "",
    };
  },
  methods: {
    onAgree() {
      this.$emit("agree", true);
    },
    onDisagree() {
      this.$emit("agree", false);
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
